import { Link }  from "react-router-dom";
export const CustomLink = ({external, url, newTab, children, ...props}) => {
    return (
        <>
        {external ?
            (<a href={url} target={newTab ? "_blank" : "_self"} style={{...props}}>{children}</a>) :
            (<Link to={url} style={{...props}}>{children}</Link>)}
        </>
    )
}